module.exports = __webpack_public_path__ + "media/images/reportes-0a5d8db8966a0786e0a6beaec5f0ae74.png";